import { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import blogPosts from '../../content/blogData';
import { BlogCard } from './BlogCard';
import './Blog.css';

const CATEGORIES = ['All', 'Beginners', 'Strategy', 'Advanced', 'Tutorials'];

export const BlogIndex = () => {
	const [activeCategory, setActiveCategory] = useState('All');
	const [isMobile, setIsMobile] = useState(window.innerWidth <= 750);

	useEffect(() => {
		const handleResize = () => setIsMobile(window.innerWidth <= 750);
		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	const filtered = activeCategory === 'All'
		? blogPosts
		: blogPosts.filter(p => p.meta.category === activeCategory);

	const faqSchema = {
		'@context': 'https://schema.org',
		'@type': 'CollectionPage',
		name: 'WagerWiz Sports Betting Blog',
		description: 'Expert guides, tutorials, and strategies for sports betting. Learn about +EV betting, arbitrage, line shopping, and more.',
		url: 'https://www.thewagerwiz.com/blog',
		publisher: {
			'@type': 'Organization',
			name: 'WagerWiz',
			url: 'https://www.thewagerwiz.com',
		},
	};

	return (
		<div className="blog-container">
			<Helmet>
				<title>Sports Betting Blog - Guides, Strategies & Tutorials | WagerWiz</title>
				<meta name="description" content="Expert sports betting guides, +EV strategies, arbitrage tutorials, and odds analysis. Learn how to bet smarter with WagerWiz." />
				<link rel="canonical" href="https://www.thewagerwiz.com/blog" />
				<meta property="og:title" content="Sports Betting Blog | WagerWiz" />
				<meta property="og:description" content="Expert sports betting guides, +EV strategies, arbitrage tutorials, and odds analysis." />
				<meta property="og:type" content="website" />
				<meta property="og:url" content="https://www.thewagerwiz.com/blog" />
				<meta name="twitter:card" content="summary_large_image" />
				<meta name="twitter:title" content="Sports Betting Blog | WagerWiz" />
				<meta name="twitter:description" content="Expert sports betting guides, +EV strategies, arbitrage tutorials, and odds analysis." />
				<script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
			</Helmet>

			<div className="blog-header">
				<h1 className="blog-title">WagerWiz Blog</h1>
				<p className="blog-subtitle">
					Expert guides, strategies, and tutorials to help you bet smarter and find your edge.
				</p>
				<div className="blog-filters">
					{CATEGORIES.map(cat => (
						<button
							key={cat}
							className={`blog-filter-btn ${activeCategory === cat ? 'active' : ''}`}
							onClick={() => setActiveCategory(cat)}
						>
							{cat}
						</button>
					))}
				</div>
			</div>

			<div className="blog-grid">
				{filtered.map(post => (
					<BlogCard key={post.meta.slug} post={post} />
				))}
			</div>

			{filtered.length === 0 && (
				<p style={{ textAlign: 'center', color: '#6b7280', marginTop: '3rem', fontSize: '1.125rem' }}>
					No posts found in this category.
				</p>
			)}
		</div>
	);
};
